import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=efcb1660&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=efcb1660&prod&lang=css"
import style1 from "./Register.vue?vue&type=style&index=1&id=efcb1660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcb1660",
  null
  
)

export default component.exports